import React, {useRef, useState} from 'react';
import {compose} from "redux";
import {Grid, IconButton, withStyles} from "@material-ui/core";
import CustomButton from "../../../../theme/CustomElements/CustomButton";
import CustomInput from "../../../../theme/CustomElements/CustomInput";
import returnIcon from "../../../../images/request/return.svg";
import {withTranslation} from "react-i18next";
import {MONTSERRAT} from "../../../../constants/fontCss";
import ErrorInput from "../../../../theme/form/Alert/ErrorInput";
import {MD, XS} from "../../../../constants/constants";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import {cleanHTML} from "../../../../functions/functions";
import axios from "axios";
import {API_ADD_NOTE_REQUEST} from "../../../../constants/apiSuffix";
import LoadingAction from "../../../../theme/LoadingAction";

const styles = (theme) => ({
    fullscreenWrapper: {

        '& .popoverEditStatus': {
            width: '90vw !important',
        },
        '& .contentDetailStatusWrapper': {
            '& .noteTextWrapper > div': {
                maxHeight: 'calc(90vh - 150px) !important',
            }
        },
    },

    screenWrapper: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        '& .popoverEditStatus': {
            width: 900,
            maxWidth: 'calc(100vw - 20px)',
            minHeight: 200
        },
        '& > div': {
            boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(60 60 60 / 10%)',
            borderRadius: 12
        },
    },
    popoverEditStatus: {
        background: '#fff',
        boxShadow: '0px 0px 20px rgba(0, 0, 254, 0.05)',
        borderRadius: 10,
        width: 400,
        [theme.breakpoints.down(XS)]: {
            maxWidth: 'calc(100vw - 20px)'
        }
    },
    headerEditStatus: {
        background: '#001529',
        boxShadow: '0px 0px 20px rgba(0, 0, 254, 0.05)',
        borderRadius: '10px 10px 0px 0px',
        color: '#fff',
        fontWeight: 600,
        padding: '0.5rem 1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    contentEditStatusWrapper: {
        padding: '1rem',
        '&.contentDetailStatusWrapper': {
            padding: 25,

            '& .noteTextWrapper': {
                border: '1px solid #E0E0E0',
                borderRadius: 6,
                padding: '16px 5px 16px 16px',
                '& > div': {
                    maxHeight: 280,
                    overflowY: 'auto',
                    whiteSpace: 'break-spaces',
                    color: '#001529',
                    fontSize: 15,
                    fontFamily: `"Nunito", sans-serif`,
                    [theme.breakpoints.up(MD)]: {
                        overscrollBehavior: 'contain',
                        touchAction: 'none',
                    },
                }
            }
        },

        '& .MuiInputBase-root':{
            padding: '18px 5px 18px 18px'
        },
        '& .statusType': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0.25rem'
        },
        '& .inputWrapper': {
            padding: '0.25rem'
        },
        '& .btnAction': {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '0.25rem'
        }
    },
    btnResponse: {
        background: '#0000FF !important',
        borderRadius: 10,
        '& .MuiButton-label': {
            fontFamily: MONTSERRAT,
            fontWeight: 700,
            fontSize: '0.875rem'
        }
    }
});

const ModalNoteForm = (props) => {
    const {onClose, classes, requestItem, t, setForceUpdate} = props;
    const [isFull, setIsFull] = useState(false);
    const contentRef = useRef(null);
    const [content, setContent] = useState((requestItem?.noteView) ?? "");
    const [errorContent, setErrorContent] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleOutsideClick = (e) => {
        if (contentRef.current && !contentRef.current.contains(e.target)) {
            if(typeof onClose === "function") {
                onClose();// Close the modal when clicking outside
            }
        }
    };

    const changeNote = (value) => {
        setErrorContent("")
        setContent(value)
    }

    const handleSave = () => {
        if (content && requestItem?.id) {
            setIsLoading(true)
            const formData = new FormData();
            formData.append("content", cleanHTML(content));
            axios.post(
                API_ADD_NOTE_REQUEST.replace("{requestId}", requestItem.id),
                formData
            )
                .then((response) => {
                    if (response.status === 200) {
                        if(typeof setForceUpdate === "function") {
                            setForceUpdate()
                        }
                        if(typeof onClose === "function") {
                            onClose();
                        }
                    } else {
                        throw new Error();
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    setIsLoading(false)

                })
        } else {
            setErrorContent(t("request.popoverAddNote.errors.noteEmpty"))
        }
    }


    const contentEl = <div className={`${classes.popoverEditStatus} popoverEditStatus`}>
        <div className={`${classes.headerEditStatus} headerEditStatus`}>
            <span>
                {t("request.list.id")}: {requestItem.id}
            </span>
            <IconButton size='small' onClick={() => setIsFull(prev => !prev)}>
                {isFull ? <FullscreenExitIcon style={{
                    color: '#fff'
                }}/> : <FullscreenIcon style={{
                    color: '#fff'
                }}/>}
            </IconButton>
        </div>
        {!!(requestItem?.onlyView) ?
            <div className={`${classes.contentEditStatusWrapper} contentDetailStatusWrapper`}>
                <div className="noteTextWrapper">
                    <div>
                        { content ?? "" }
                    </div>
                </div>
            </div> :
            <div className={`${classes.contentEditStatusWrapper} contentEditStatusWrapper`}>
                <Grid container>
                    <Grid item xs={12} lg={12} className={"inputWrapper"}>
                        <CustomInput multiline
                                     rows={isFull ? 11 : 8}
                                     rowsMax={isFull ? 11 : 8}
                                     value={content}
                                     onChange={(e) => changeNote(e.target.value)}
                                     placeholder={t("request.popoverAddNote.note")}
                                     className={"comment"}
                                     validate={errorContent}
                        />
                        <ErrorInput textValidate={errorContent}/>
                    </Grid>
                    <Grid item xs={12} lg={12} className={"btnAction"}>
                        <CustomButton
                            className={classes.btnResponse}
                            title={props.t("request.popoverAddNote.btnAddNote")}
                            onClick={handleSave}
                            buttonProps={{
                                startIcon: <React.Fragment><img
                                    src={returnIcon} className={"iconAdd"} alt=""/></React.Fragment>
                            }}

                        />
                    </Grid>
                </Grid>
            </div>}
    </div>

    return (
        <div className={`${classes.screenWrapper} ${isFull ? classes.fullscreenWrapper : ""}`}
             onClick={handleOutsideClick}>
            {isLoading && <LoadingAction />}

            <div ref={contentRef}>
                {contentEl}
            </div>
        </div>
    )

}

export default compose(withStyles(styles), withTranslation())(ModalNoteForm);
